var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticStyle: { height: "48px", "flex-wrap": "nowrap" } },
        [
          _c(
            "v-layout",
            { staticClass: "roomTileHeader", attrs: { row: "" } },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "span",
                    { staticClass: "roomName", style: _vm.roomNameStyle },
                    [_vm._v(_vm._s(_vm.room.name))]
                  ),
                  _vm.showOccupancyBadge
                    ? _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "grey",
                            "text-color": "white",
                            cursor: "pointer",
                            disabled: ""
                          }
                        },
                        [_vm._v(_vm._s(_vm.badgeText))]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { xs: "", icon: "", flat: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.cancel()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        {
          staticStyle: { height: "calc(90vh - 104px)", "overflow-y": "hidden" }
        },
        [
          _c("v-layout", { attrs: { row: "" } }, [
            _c(
              "span",
              { staticClass: "roomCardValue", style: _vm.editStyle },
              [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Room Type")
                ]),
                _vm.isEditable
                  ? _c("v-select", {
                      staticClass: "staySelector",
                      attrs: {
                        items: _vm.roomTypeCodes,
                        outline: "",
                        "item-value": "code",
                        "item-text": "displayName"
                      },
                      model: {
                        value: _vm.roomTypeCodeValue,
                        callback: function($$v) {
                          _vm.roomTypeCodeValue = $$v
                        },
                        expression: "roomTypeCodeValue"
                      }
                    })
                  : _vm._e(),
                !_vm.isEditable
                  ? _c("div", { staticStyle: { "margin-top": "6px" } }, [
                      _vm._v(_vm._s(_vm.roomTypeCodeDisplayName))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "span",
              { staticClass: "roomCardValue", style: _vm.editStyle },
              [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Room Status")
                ]),
                _vm.isEditable
                  ? _c("v-select", {
                      staticClass: "staySelector",
                      attrs: {
                        items: _vm.roomStatusCodes,
                        outline: "",
                        "item-value": "code",
                        "item-text": "displayName"
                      },
                      model: {
                        value: _vm.roomStatusCodeValue,
                        callback: function($$v) {
                          _vm.roomStatusCodeValue = $$v
                        },
                        expression: "roomStatusCodeValue"
                      }
                    })
                  : _vm._e(),
                !_vm.isEditable
                  ? _c("div", { staticStyle: { "margin-top": "6px" } }, [
                      _vm._v(_vm._s(_vm.roomStatusCodeDisplayName))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "span",
              { staticStyle: { width: "100%" } },
              [
                _c("div", { staticClass: "ntstValueLabel" }, [_vm._v("Note")]),
                _c("v-text-field", {
                  attrs: { outline: "" },
                  model: {
                    value: _vm.room.currentNote,
                    callback: function($$v) {
                      _vm.$set(_vm.room, "currentNote", $$v)
                    },
                    expression: "room.currentNote"
                  }
                })
              ],
              1
            )
          ]),
          _c("v-divider"),
          _c(
            "v-layout",
            { staticStyle: { "overflow-x": "auto" }, attrs: { row: "" } },
            _vm._l(_vm.actionableStays, function(stay, index) {
              return _c(
                "v-flex",
                { key: index },
                [
                  _c("stay-card", {
                    attrs: {
                      unit: _vm.unit,
                      room: _vm.room,
                      stay: stay,
                      isCloseVisible: false,
                      isEditable: false,
                      isShowingInRoomCard: true,
                      isStaffNotesEditable: false
                    }
                  })
                ],
                1
              )
            })
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "ntstAppButton",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.cancel()
                }
              }
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "ntstAppButton",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.save()
                }
              }
            },
            [_vm._v("\n      Save\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }